<body>
  <main class="memic-main memic-main--bg">
    <section *ngIf="loading">
      Loading....
    </section>

    <div *ngIf="!loading" class="loading-spinner">
      <safetydirector-toasts aria-live="polite" aria-atomic="true"></safetydirector-toasts>
      <safetydirector-nav-menu></safetydirector-nav-menu>

      <!-- External Link Modal Popup -->
      <app-external-link-modal
        *ngIf="showModal"
        (confirm)="confirmNavigation()"
        (cancel)="cancelNavigation()">
      </app-external-link-modal>
    
      <div class="memic-content" >
        <!-- We need to preserve the Jumbotron Page Styles -->
        <div [ngClass]="jumbotronPage === true ?  '' : 'memic-page p-t-4 memic-page--boxed'">
          <router-outlet *ngIf="!isIframe"></router-outlet>
        </div>
      </div>      
    </div>
    <footer>
      <app-footer [footerClass]="footerClass" [isLoaded]="isLoaded"></app-footer>
    </footer>
  </main>
</body>
